import React from 'react';
import RemoveModalTemplate from '@component/gridgio/modal/dialog-modal/remove-modal-template';
import { useTypedDispatch } from '@hook/common/useStore';
import { useModifyProjectMutation } from '@hook/gridgio/useApi';
import { actions as modalActions } from '@store/slice/gridgio/modal-slice';
import type { IProjectBookmarkRemoveModalData } from '@datatype/gridgio/type';
import { ETheme } from '@datatype/type';

interface IProps {
  data: IProjectBookmarkRemoveModalData['data'];
}

const ProjectBookmarkRemoveModal: React.FC<IProps> = ({ data }) => {
  const dispatch = useTypedDispatch();
  const mutation = useModifyProjectMutation();

  const handleCancel = () => {
    if (!mutation.isPending) dispatch(modalActions.hideModal());
  };
  const handleRemove = async () => {
    if (mutation.isPending) return;
    try {
      await mutation.mutateAsync({ projectKey: data.projectKey, isBookmark: false });
      dispatch(modalActions.hideModal());
    } catch {}
  };

  return (
    <RemoveModalTemplate
      title='고정을 해제할까요?'
      description='전체 목록에서 계속 볼 수 있습니다.'
      confirmText='고정 해제'
      confirmTheme={ETheme.RED}
      isPending={mutation.isPending}
      handleCancel={handleCancel}
      handleRemove={handleRemove}
    />
  );
};

export default ProjectBookmarkRemoveModal;
